import { BaseService } from './base.service';
import { IBaseListingModel, BaseListingModel } from '../models/base-listing.model';
import { Uris } from '../common/constants';
import { SearchEntities } from '../common/enums';

export interface IOwnerService {
  getOwnerByBlockId(blockId: string, param: any): Promise<any>
  getBlockOwnerById(blockId: string, ownerId: string): Promise<any>
}

export class OwnerService extends BaseService implements IOwnerService {
  getOwnerByBlockId(blockId: string, param: any): Promise<any> {
    return super.get(Uris.BlockOwners.replace(':id', blockId), param)
      .then(response => response)
      .catch(err => err)
  }
  getBlockOwnerById(blockId: string, ownerId: string) {
    return super.get(Uris.BlockOwnerId.replace(':id', blockId).replace(':cid', ownerId))
      .then(response => response)
      .catch(error => error)
  }
}



// WEBPACK FOOTER //
// ./src/services/owner.service.ts